import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newTrip() {
    let tripDetails = {
      truck_id: $(".truck_id").val(),
      loading_date: $(".loading_date").val(),
      cfs_id: $(".cfs_id").val(),
      trip_charge: $(".trip_charge").val(),
      consignee_id: $(".consignee_id").val(),
      container_no: $('.container_no').val()
    };
    console.log(tripDetails);
    $(".creatingTrip").hide();
    $(".creatingTripLoader").show();
    baseurl.post(rt.newTrip, tripDetails).then(res => {
      $(".creatingTrip").show();
      $(".creatingTripLoader").hide();

      if (res.data.code === 200) {
        $(".form-control").val("");
        suc.tripsdocumentCreateSuccess();
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 403) {
        ers.TripsExists();
      } else if (res.data.code === 404) {
        ers.errorCreatingTrips();
      } else if (res.data.code === 405) {
        ers.noPermissionToCreate();
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  },

  loadTrips({ commit }) {
    baseurl.get(rt.loadTrips).then(res => {
      $(".tripsLoader").hide();

      if (res.data.code === 200) {
        commit("STORE_TRIPS", res.data.trips);
      } else if (res.data.code === 404) {
        ers.errorLoadingTrips();
      } else if (res.data.code === 405) {
        ers.noPermissionToRead();
        commit("STORE_TRIPS", []);
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  },

  viewTrip({ commit }, tripId) {
    commit("STORE_TRIP_UPDATE", tripId);
    window.$("#update-trip").modal("hide");
  },
  viewCommission({ commit }, tripId) {
    commit("STORE_TRIP_UPDATE", tripId);
    router.push("/addcommission");
  },

  updateTrip({ commit }) {
    let tripDetails = {
      id: $(".id").val(),
      trip_status: $(".trip_status").val(),
      payment_status: $(".payment_status").val()
    };
    $(".updatingTrip").hide(), $(".updatingTripLoader").show();
    baseurl.post(rt.updateTrip, tripDetails).then(res => {
      $(".updatingTrip").show(), $(".updatingTripLoader").hide();

      if (res.data.code === 200) {
        suc.tripsdocumentUpdateSuccess();
        commit("STORE_TRIPS", res.data.trips);
        window.$("#update-trip").modal("hide");
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 404) {
        ers.errorUpdatingTrips();
      } else if (res.data.code === 405) {
        ers.noPermissionToUpdate();
        window.$("#update-trip").modal("hide");
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/trips/actions.js